import cookie from '../cookie';
/**
 * 获取环境配置
 */
export function getEnvConfig(){
    const env = cookie.get('frontEnv')||'';
    return {
        env
    }
}

/**
 * 是否是正式环境
 * 如果frontEnv为test 则为docker环境
 */
export function getIsEnvProduction(){
    const envConfig = getEnvConfig();
    return envConfig.env !== 'test';
}